import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { ChecklistItemCollection } from '../index'

export const setupChecklistItemReplication = (
  collection: ChecklistItemCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'checklistitems',
    displayName: 'ChecklistItem',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      checklistId: doc.workItemListId || doc.checklistId,
      content: doc.content,
      isCompleted: doc.isCompleted || false,
      sortOrder: doc.sortOrder ?? null,
      isDeleted: doc.isDeleted || false,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy || null,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      workItemListId: state.checklistId,
      content: state.content,
      isCompleted: state.isCompleted,
      sortOrder: state.sortOrder || null,
      isDeleted: state.isDeleted,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
